<template>
  <div v-show="visible">
    <div class="mask"></div>
    <div class="subject-end">
      <div class="bg-content"></div>
      <div class="dialog-content">
        <p class="title">温馨提示</p>
        <div class="content-body">
          <h2>考试已经结束，请您离开考场！</h2>
           <span class="gray" v-if="isCountDown">正保AI系统正在认真阅卷中，请等待({{countdown}}s)</span>
          <span class="gray" v-else-if="commonInfo.aiScoring">试卷中主观题，将由正保AI系统判分</span>
          <span class="orange" v-else >注意：本次考试仅统计客观成绩，不再进行主观题打分！</span>
          <div class="option">
            <a href="javascript:void(0)" v-if="commonInfo.aiScoring"
               @click="checkScore">查看成绩</a>
            <a href="javascript:void(0)" v-else-if="stage === -1"
               @click="viewResults">查看答题成绩</a>
            <a href="javascript:void(0)" v-else-if="stage=== 1 || stage=== 2 || stage=== 3"
               @click="viewResults">查看成绩</a>
            <a href="javascript:void(0)" v-else
               @click="viewResults">查看解析</a>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'subjectEnd',
  props: {
    visible: { type: Boolean },
    isHaveSubjective: { type: Boolean },
    activity: { type: String },
    query: { type: String },
    subFlag: { type: Boolean},
    stage:{ type: Number,default:-1},
     isCountDown: { type: Boolean},
      countdown: { type: Number },
  },
  computed: {
    ...mapGetters([
      'commonInfo',
    ]),
   },
  methods: {
    closeDialog(){
      if(this.$route.query.flag === 'ordinary'){
        window.location.href="about:blank"
        window.close()
        return
      }
      this.$emit('update:visible', false)
      this.$router.push({name: 'examSystem', query: {siteCourseID:this.siteCourseID, courseID:this.courseID}})
    },
    subjectiveQuestionsStore () {
      this.$emit('subjectiveQuestionsStore')
    },
    viewResults() {
      this.$emit('viewResults')
    },
    checkScore(){
      this.$emit('checkScore')
    }
  },
  mounted(){
    const { siteCourseID, courseID } = this.$route.query
    this.courseID = Number(courseID)
    this.siteCourseID = Number(siteCourseID)
  }
}
</script>
